import { CallToActionSplit } from "../../../../modules/content/components/CallToActionSplit/CallToActionSplit";
import { CallToActionStacked } from "../../../../modules/content/components/CallToActionStacked/CallToActionStacked";
import { RavioliSection } from "../../../../modules/content/components/RavioliSection/RavioliSection";
import type { ICallToActionBlockProps } from "./CallToActionBlock.props";

export const CallToActionBlock = (props: ICallToActionBlockProps) => {
  const { anchorId, buttons, description, eyebrow, heading, image, parentClass, spacing, variant } =
    props;
  if (!eyebrow && !heading && !description && !buttons?.length && !image) return null;

  return (
    <RavioliSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="border border-primary bg-primary p-7 text-canvas shadow-ravioli-ink-lg md:p-12 lg:p-16">
        {variant === "split" ? (
          <CallToActionSplit {...props} />
        ) : (
          <CallToActionStacked {...props} />
        )}
      </div>
    </RavioliSection>
  );
};

CallToActionBlock.displayName = "Block::CallToActionBlock";
